'use client';

import { ReactNode, useMemo } from 'react';

import { Typography, TypographyProps } from '@mui/material';
import { useTranslations } from 'next-intl';

import styles from './SectionTitle.module.scss';

interface SectionTitleProps extends Omit<TypographyProps, 'children'> {
  translationNamespace: Parameters<typeof useTranslations>[0];
  translationKey: string;
  icon: ReactNode;
}

const createIconRenderer = (icon: ReactNode) => () => <span>{icon}</span>;

const SectionTitle = ({
  translationNamespace,
  translationKey,
  icon,
  variant = 'h2',
  component = 'h2',
  className,
  ...rest
}: SectionTitleProps) => {
  const t = useTranslations(translationNamespace);

  const richTextComponents = useMemo(
    () => ({
      icon: createIconRenderer(icon),
    }),
    [icon]
  );

  return (
    <Typography component={component} variant={variant} className={`${styles.title} ${className || ''}`} {...rest}>
      {t.rich(
        translationKey as Parameters<typeof t.rich>[0],
        richTextComponents as unknown as Parameters<typeof t.rich>[1]
      )}
    </Typography>
  );
};

export default SectionTitle;
